<template>
  <div id="app">
    <Player v-if="!isAdmin && !isCreateQuiz && !isPrivacyPolicy" />
    <Admin v-if="isAdmin" />
    <CreateQuiz v-if="isCreateQuiz" />
    <PrivacyPolicy v-if="isPrivacyPolicy" />
  </div>
</template>

<script>
import Player from './components/Player.vue'
import Admin from './components/Admin.vue'
import CreateQuiz from './components/CreateQuiz.vue'
import PrivacyPolicy from './components/PrivacyPolicy.vue'

export default {
  name: 'App',
  data: function() {
    return {
      isAdmin: document.location.href.indexOf('/admin') != -1,
      isCreateQuiz: document.location.href.indexOf('/create-quiz') != -1,
      isPrivacyPolicy: document.location.href.indexOf('/privacy-policy') != -1,
    };
  },
  components: {
    Player,
    Admin,
    CreateQuiz,
    PrivacyPolicy
  }
}
</script>

<style>

</style>
